import { render, staticRenderFns } from "./WidgetContainer.vue?vue&type=template&id=60112460&scoped=true&"
import script from "./WidgetContainer.vue?vue&type=script&lang=js&"
export * from "./WidgetContainer.vue?vue&type=script&lang=js&"
import style0 from "./WidgetContainer.vue?vue&type=style&index=0&id=60112460&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60112460",
  null
  
)

export default component.exports